<template>
  <button type="submit" class="inline-flex items-center" :class="{ 'pointer-events-none opacity-70': form.busy }" :disabled="form.busy" :aria-disabled="form.busy">
    <svg v-if="form.busy && spinner" class="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
    </svg>

    <slot />
  </button>
</template>

<script>
export default {
  name: 'Button',

  props: {
    form: {
      type: Object,
      required: true
    },

    spinner: {
      type: Boolean,
      default: true
    }
  }
}
</script>
